(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["retractation-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var STORAGE_KEY = 'retractation-submission';

    var FIELD_LABELS = {
      firstname: 'Prénom',
      name: 'Nom',
      email: 'Adresse email',
      order: 'Numéro de commande',
      products: 'Produit(s) concerné(s)',
      details: 'Informations complémentaires',
      ack: 'Accusé de réception souhaité'
    };

    function getParams() {
      try {
        return new URLSearchParams(window.location.search);
      } catch (e) {
        return new URLSearchParams('');
      }
    }

    function renderSummary(listEl, data) {
      if (!listEl) return;
      listEl.innerHTML = '';
      Object.keys(FIELD_LABELS).forEach(function (key) {
        var value = data[key];
        if (!value) return;
        var row = document.createElement('div');
        var dt = document.createElement('dt');
        var dd = document.createElement('dd');
        dt.textContent = FIELD_LABELS[key];
        dd.textContent = value;
        row.appendChild(dt);
        row.appendChild(dd);
        listEl.appendChild(row);
      });
    }

    function initReceipt(receipt) {
      var stored = null;
      try {
        stored = JSON.parse(window.sessionStorage.getItem(STORAGE_KEY) || 'null');
      } catch (e) {
        stored = null;
      }

      if (stored) {
        var summaryWrap = receipt.querySelector('[data-receipt-summary]');
        renderSummary(receipt.querySelector('[data-receipt-summary-list]'), stored.data || {});
        if (summaryWrap) summaryWrap.hidden = false;
        if (stored.date) {
          var dEl = receipt.querySelector('[data-receipt-date]');
          if (dEl) dEl.textContent = stored.date;
        }
        if (stored.time) {
          var tEl = receipt.querySelector('[data-receipt-time]');
          if (tEl) tEl.textContent = stored.time;
        }
        try {
          window.sessionStorage.removeItem(STORAGE_KEY);
        } catch (e) {}
      }

      var printBtn = receipt.querySelector('[data-receipt-print]');
      if (printBtn) {
        printBtn.addEventListener('click', function () {
          window.print();
        });
      }
    }

    function initForm(form) {
      var fields = {};
      Object.keys(FIELD_LABELS).forEach(function (key) {
        fields[key] = form.querySelector('[data-retractation-field="' + key + '"]');
      });

      var params = getParams();
      var prefillKeys = ['order', 'email', 'name', 'firstname', 'products'];
      prefillKeys.forEach(function (key) {
        var value = params.get(key);
        if (value && fields[key] && !fields[key].value) {
          fields[key].value = value;
        }
      });

      var orderName = params.get('order');
      if (orderName) {
        var orderBanner = document.querySelector('[data-retractation-order-banner]');
        var orderNameEl = document.querySelector('[data-retractation-order-name]');
        if (orderBanner && orderNameEl) {
          orderNameEl.textContent = orderName;
          orderBanner.hidden = false;
        }
      }

      var fillStep = form.querySelector('[data-retractation-step="fill"]');
      var confirmStep = form.querySelector('[data-retractation-step="confirm"]');
      var reviewBtn = form.querySelector('[data-retractation-review]');
      var backBtn = form.querySelector('[data-retractation-back]');
      var recapList = form.querySelector('[data-retractation-recap]');
      var timestampInput = form.querySelector('[data-retractation-timestamp]');
      var submitBtn = form.querySelector('[data-retractation-submit]');

      function collectData() {
        var data = {};
        Object.keys(fields).forEach(function (key) {
          if (fields[key]) data[key] = (fields[key].value || '').trim();
        });
        return data;
      }

      if (reviewBtn && confirmStep && fillStep) {
        reviewBtn.addEventListener('click', function () {
          var requiredEls = fillStep.querySelectorAll('[required]');
          for (var i = 0; i < requiredEls.length; i++) {
            if (!requiredEls[i].checkValidity()) {
              requiredEls[i].reportValidity();
              return;
            }
          }
          renderSummary(recapList, collectData());
          fillStep.hidden = true;
          confirmStep.hidden = false;
          confirmStep.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }

      if (backBtn && fillStep && confirmStep) {
        backBtn.addEventListener('click', function () {
          confirmStep.hidden = true;
          fillStep.hidden = false;
        });
      }

      form.addEventListener('submit', function () {
        if (submitBtn) {
          var txt = submitBtn.querySelector('[data-submit-text]');
          var ldr = submitBtn.querySelector('[data-submit-loader]');
          if (txt) txt.hidden = true;
          if (ldr) ldr.hidden = false;
          submitBtn.classList.add('is-loading');
          submitBtn.setAttribute('aria-busy', 'true');
        }

        var now = new Date();
        var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
        var dateStr = pad(now.getDate()) + '/' + pad(now.getMonth() + 1) + '/' + now.getFullYear();
        var timeStr = pad(now.getHours()) + ':' + pad(now.getMinutes());
        if (timestampInput) timestampInput.value = dateStr + ' ' + timeStr;
        try {
          window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
            data: collectData(),
            date: dateStr,
            time: timeStr
          }));
        } catch (e) {}
      });
    }

    function init() {
      var receipt = document.querySelector('[data-retractation-receipt]');
      if (receipt) {
        initReceipt(receipt);
        return;
      }
      var form = document.querySelector('.retractation__form');
      if (form) initForm(form);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
